import {  gsap } from "gsap";
import { Helper } from "../../../dev/utils/Helper";
import { GameData } from "../../server/data/BaseModel";
import { ArrayHelper } from "../../../dev/utils/ArrayHelper";
import { GameSetting } from "../../../dev/setting/GameSetting";
import { SoundManager } from "../../config/sound/SoundManager";

import { StopPresentation } from "../general/StopPresentation";

import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { RoadRageEngineController } from "../../reel/RoadRageEngineController";
import { RoadRage } from '../../RoadRage';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class SetupStopPresentation extends StopPresentation {

    private stopFromRight:boolean = false;
    private lastReel:number = 0;
    private constructionRev:string[][] = [];
    private constructionPos:number[][] = [];
    private isRetrigged:boolean = false;

    constructor() {
        super();
    }

    setGamedData(data: GameData): void {
        super.setGamedData(data);
        this.stopFromRight = data.Reel.isCarOnReel(4);
        this.lastReel = this.stopFromRight ? 4 : 0;

        this.isRetrigged = this.isRetrigged = RoadRageEngineManager.AllReels.findIndex(r => !r.isActive) >= 0;
        this.constructionRev = Helper.fetchOrApply(data.Reel.constructionValues, []);
        this.constructionPos = Helper.fetchOrApply(data.Reel.constructionPositions, []);
    }

    preStart(): void {
        this.animationTl = Helper.setTimeline(this.animationTl, new gsap.core.Timeline());
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(!RoadRageEngineManager.isQuickStop);

        if(this.readyToDefineStop()){
            if(!this.isRetrigged) RoadRageEngineManager.getReel(4).attention(true);
            
            this.createStopSpins();

            const delay: number[] = this.defineDelays();
            const stopOrder:number[] =  [0,1,2,3,4];

            RoadRageEngineManager.stopReels(this.stopFromRight ? delay : delay.reverse(), this.stopFromRight ? stopOrder : stopOrder.reverse());
        }
    }

    createStopSpins(): void {
        RoadRageEngineManager.RAll((rc: RoadRageEngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }, false));
    }

    defineDelays(): number[] {
        
        const baseStopDelay:number[] = [0.5, 1, 1.5, 2, 3];
        const modeSpeed:number = GameSetting.isFastSpin ? 0.5 : 1;

        const delay: number[] = ArrayHelper.initArrayWithValues(RoadRageEngineManager.AllReels.length, (i) => {
            return  (baseStopDelay[i] * modeSpeed);
        })

        return RoadRageEngineManager.isQuickStop ? [0, 0.01, 0.02, 0.03, 0.04] : delay;
    }

    onStops(rc: RoadRageEngineController): void {
        rc.attention(false);

        super.onStops(rc);
        
        if(rc.reelID === this.lastReel) rc.switchToGlowPos();
    }

    protected symbolTypePos(symType: string | string[], windowReel: string[][]): number[][] {

        const res: number[][] = [];
        const isArray: boolean = !(typeof symType === 'string');

        for (let r: number = 0; r < windowReel.length; r++) {
            res.push([]);
            for (let c: number = 0; c < windowReel[r].length; c++) {
                if (isArray)
                    res[r].push(symType.indexOf(windowReel[r][c]) >= 0 ? c : -1)
                else
                    res[r].push(windowReel[r][c] === symType ? c : -1);
            }
        }
        return res;
    }

    onBounce(rc: RoadRageEngineController): void {
        // Perhaps 
        // rc.AllWindowSymbols.forEach(s => { s.onBounceEffect(); });
        this.playBounceSound(rc.reelID);
    }

    onStopped(rc: RoadRageEngineController): void {
        const startPos:number = this.animationTl.time();
        this.constructionPos[rc.reelID].forEach((v,indx) => {
            this.animationTl.add(rc.getSymbol(v)?.changeConstruction(this.constructionRev[rc.reelID][indx],0.5)!,startPos);
        })
    }

    done(): void {
        RoadRage.reelManager.applyMask(false);
        RoadRageEngineManager.RAll(r => r.attention(false));
        SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
    }
}